import { useCallback, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';

import { Button, Flex, Loading, Page } from 'components';

import { createUrl, request } from 'app/utils';
import usestorage from 'app/utils/storage';
import { useAuth } from 'features/auth';
import { useSchool } from 'features/school';

import { CenteredLayout } from '../components';
import useEducational from '../useEducational';

const Switcher = () => {
  const navigate = useNavigate();
  const [, , removeCookie] = useCookies(['token']);

  const [loading, setLoading] = useState(true);

  const { activateCode } = useEducational();

  const { isLogged, setLogged } = useAuth();
  const { apiGatewayUrl } = useSchool();

  const storage = usestorage('sessionStorage');

  const goToRegister = useCallback(
    async (hasRegister: boolean) => {
      if (isLogged) {
        setLoading(true);

        await request({
          url: '/api/v1/user/Unauthentication',
          method: 'get',
          baseURL: apiGatewayUrl,
        }).finally(() => {
          setLogged(false);
          removeCookie('token', {
            path: '/',
            domain: window.location.hostname,
          });
          setLoading(false);
        });
      }

      if (hasRegister) {
        storage.set('redirect_url', `${createUrl('educational/register')}?logged=true`);
        navigate(createUrl('login'));
      } else {
        // console.log('foi pro registro');
        navigate(createUrl('educational/register'), { replace: true });
      }
    },
    [isLogged]
  );

  useEffect(() => {
    if (activateCode) {
      setLoading(false);
    } else {
      navigate(createUrl('educational/activate/code'));
    }
  }, [activateCode]);

  return (
    <Page title="MELVER nas Escolas">
      {loading && <Loading alpha />}

      <CenteredLayout>
        <Flex flexDirection="column" style={{ gap: 10 }}>
          <Button color="white" py={4} onClick={() => goToRegister(false)}>
            Ainda não tenho cadastro
          </Button>

          <Button
            py={4}
            bg="transparent"
            bgHover="primary_200"
            bgClick="primary_400"
            color="primary_400"
            colorHover="white"
            colorClick="white"
            borderColor="primary_400"
            borderColorHover="primary_200"
            onClick={() => goToRegister(true)}
          >
            Já tenho cadastro
          </Button>
        </Flex>
      </CenteredLayout>
    </Page>
  );
};

export default Switcher;
